var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.16 15.4909L28.014 0.641602L42.8633 15.4909C46.8016 19.4298 49.0139 24.7719 49.0135 30.3419C49.013 35.9119 46.7999 41.2536 42.861 45.1919C40.9107 47.142 38.5953 48.6888 36.0472 49.744C33.499 50.7993 30.768 51.3423 28.01 51.342C22.44 51.3416 17.0983 49.1285 13.16 45.1896C11.2099 43.2396 9.66307 40.9245 8.60771 38.3767C7.55235 35.8288 7.00916 33.098 7.00916 30.3403C7.00916 27.5825 7.55235 24.8517 8.60771 22.3039C9.66307 19.756 11.2099 17.441 13.16 15.4909ZM30.345 25.6736V15.1736L19.845 30.3403H25.6783V40.8403L36.1783 25.6736H30.345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon_security.1dbb75ed8aba281afa12e03195f5db36.svg";
export { ForwardRef as ReactComponent };